// External libraries
import React, { useState } from 'react';
import { string } from 'prop-types';

// Internal modules
import { getContent } from '@/lib';
import { HonorFxButton, HonorFxContent } from './StyledComponents';
import { HIGH_CONTRAST_TEXT_COLOR } from '@/styles';

const RATE_AND_HONOR_CONTENT_KEYS = {
  feeRateContentKey: 'currencyConversion.paypalDisclosure.feeRate',
  honorFXContentKey: 'currencyConversion.paypalDisclosure.honorFx.content',
};

const FeeDisclosure = ({ feeRate }) => {
  const [isOpen, toggleIsOpen] = useState(false);
  const handleClick = () => toggleIsOpen(!isOpen);

  const { feeRateContentKey, honorFXContentKey } = RATE_AND_HONOR_CONTENT_KEYS;

  return (
    <>
      <p>
        {getContent(feeRateContentKey, { feeRate: <span>{feeRate}</span> })}
      </p>

      <HonorFxButton isOpen={isOpen} onClick={handleClick}>
        {getContent('currencyConversion.paypalDisclosure.honorFx.button')}
      </HonorFxButton>

      {isOpen && (
        <HonorFxContent>{getContent(honorFXContentKey)}</HonorFxContent>
      )}
    </>
  );
};

FeeDisclosure.propTypes = {
  feeRate: string,
};

const ConversionRate = ({ content, rate }) => {
  return (
    <dl style={{ color: HIGH_CONTRAST_TEXT_COLOR }}>
      <dt>{content}</dt>
      <dd>{rate}</dd>
    </dl>
  );
};

ConversionRate.propTypes = {
  content: string,
  rate: string,
};

export { FeeDisclosure, ConversionRate };
